import { ReactNode } from 'react'

interface HeaderContentProps {
  title: string | ReactNode
  subtitle?: string
}

export function HeaderContent({ title, subtitle = undefined }: HeaderContentProps) {
  return (
    <div className='modal-title select-none'>
      <p>{title}</p>
      {subtitle && <span className='text-neutral-400 font-light'>{subtitle}</span>}
    </div>
  )
}
